import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function insert(data){
  return request({
    url:applicationName+'/admin/companyshow',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deleted(data){
  return request({
    url:applicationName+'/admin/companyshow',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}


export function query(data){
  return request({
    url:applicationName+'/admin/companyshow',
    method:'get',
    params:data
  })
}

export function queryList(data){
  return request({
    url:applicationName+'/admin/companyshow/list',
    method:'get',
    params:data
  })
}

export function update(data){
  return request({
    url:applicationName+'/admin/companyshow',
    method:'put',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}